import { render, staticRenderFns } from "./TruckFilters.vue?vue&type=template&id=55ffa6a1&scoped=true"
import script from "./TruckFilters.vue?vue&type=script&lang=ts"
export * from "./TruckFilters.vue?vue&type=script&lang=ts"
import style0 from "./TruckFilters.vue?vue&type=style&index=0&id=55ffa6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffa6a1",
  null
  
)

export default component.exports